import { render, staticRenderFns } from "./AddHospital.vue?vue&type=template&id=2cb2359a&scoped=true"
import script from "./AddHospital.vue?vue&type=script&lang=js"
export * from "./AddHospital.vue?vue&type=script&lang=js"
import style0 from "./AddHospital.vue?vue&type=style&index=0&id=2cb2359a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2359a",
  null
  
)

export default component.exports